import { Component, OnInit } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { AuthService } from 'src/app/services/auth.service';
import { UsersService } from 'src/app/services/users.service';
import { ToastrService } from 'ngx-toastr';
import LoginResponse from 'src/app/interfaces/auth/LoginResponse';
import { UserRole } from 'src/app/enums/user/UserRole';
import { IUser } from 'src/app/interfaces/user/UserRecord';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public submitted: boolean = false;
  public publicKey: string;
  public isForgotPassword: boolean = false;
  public forgotPasswordForm: FormGroup;
  public isOtpGenerated: boolean = false;
  public isOtpVerified: boolean = false;
  constructor(private router: Router,
    private authService: AuthService,
    private usersService: UsersService,
    private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.loginForm = new FormGroup({
      email: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required)
    })
  }

  onClickSignUp() {
    this.router.navigate(['signup']);
  }

  onClickForgotPassword() {
    this.isForgotPassword = true;
    this.forgotPasswordForm = new FormGroup({
      email: new FormControl(''),
      otp: new FormControl(''),
      newPassword: new FormControl(''),
      confirmPassword: new FormControl('')
    })
  }

  onGenerateOtp() {
    let body = {
      email: this.forgotPasswordForm.get('email').value
    }
    this.usersService.generateOtp(body).subscribe(
      (res: any) => {
        this.isOtpGenerated = true;
        this.toastrService.success('OTP sent');
      },
      (error => {
        this.toastrService.error(error.message || "Somthing is wrong, this should never happen");
      })
    )
  }

  onVerifyOtp() {
    let body = {
      email: this.forgotPasswordForm.get('email').value,
      otp: this.forgotPasswordForm.get('otp').value
    }
    this.usersService.verifyOtp(body).subscribe(
      (res: any) => {
        this.isOtpGenerated = true;
        this.isOtpVerified = true;
        this.toastrService.success('OTP verified');
      },
      (error => {
        this.toastrService.error(error.message || "Somthing is wrong, this should never happen");
      })
    )
  }

  onUpdatePassword() {
    if (this.forgotPasswordForm.get('newPassword').value === this.forgotPasswordForm.get('confirmPassword').value) {
      let body = {
        email: this.forgotPasswordForm.get('email').value
      }
      this.authService.getPublicKey().subscribe(
        (res: any) => {
          this.publicKey = res.key;
          body['password'] = this.authService.encryptWithPublicKey(this.forgotPasswordForm.get('confirmPassword').value, this.publicKey);
          this.usersService.updatePassword(body).subscribe((res: any) => {
            this.isForgotPassword = false;
            this.isOtpGenerated = false;
            this.isOtpVerified = false;
          })
        },
        (error => {
          this.toastrService.error(error.message || "Somthing is wrong, this should never happen");
        })
      )
    }
  }

  async onLogin() {
    try {
      this.submitted = true;
      if (this.loginForm.valid) {

        /* Login Auth Logic. */
        const loginFormValue = _.get(this.loginForm, 'value');
        const { message, id: userId }: LoginResponse = await this.authService.login(loginFormValue).toPromise();
        this.toastrService.success(message);

        /* Get user details and set session. */
        const userDetails: IUser = await this.usersService.getUserDetails(userId).toPromise();
        const userSessionPayload = _.omit(userDetails, 'photo');
        this.authService.isAdmin = userDetails.role === UserRole.ADMIN;
        this.authService.loggedIn = true
        sessionStorage.setItem('logged-in-user', JSON.stringify(userSessionPayload));

        this.router.navigate([`/student/${userId}/dashboard`]);
      }
    }
    catch (err) {
      this.toastrService.error(err?.error?.message || err.message || "Something went wrong, this should never happen");
    }
  }
}
